import type { SVGProps } from 'react';

const SvgFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="filter">
      <path d="M.53 3.19v25.62a2.76 2.76 0 0 0 2.75 2.75h25.44a2.76 2.76 0 0 0 2.75-2.75V3.19A2.76 2.76 0 0 0 28.72.44H3.28A2.76 2.76 0 0 0 .53 3.19Zm29.47 0v25.62a1.25 1.25 0 0 1-1.25 1.25H3.28A1.25 1.25 0 0 1 2 28.81V3.19a1.25 1.25 0 0 1 1.28-1.25h25.44A1.25 1.25 0 0 1 30 3.19Z" />
      <path d="M16.21 12.9a.75.75 0 0 0 .75.75h5.57a.76.76 0 0 0 .75-.75v-2H27V9.36h-3.7v-2a.75.75 0 0 0-.75-.75H17a.74.74 0 0 0-.75.75v2H5v1.5h11.21Zm1.5-4.82h4.07v4.07h-4.07ZM8.72 24.67a.75.75 0 0 0 .75.75H15a.74.74 0 0 0 .75-.75v-2H27v-1.5H15.79v-2a.75.75 0 0 0-.75-.75H9.47a.76.76 0 0 0-.75.75v2H5v1.5h3.7Zm1.5-4.82h4.07v4.07h-4.07Z" />
    </g>
  </svg>
);

export default SvgFilter;
